"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const opportunity_1 = require("./opportunity");
const enums_1 = require("../../../@shared-types/opportunites/enums");
const users_service_1 = require("../../../../../shared/users/users.service");
let OpportunintyAssignmentFormComponent = class OpportunintyAssignmentFormComponent {
    constructor(opportunityModel, userService) {
        this.opportunityModel = opportunityModel;
        this.userService = userService;
        this.data = { title: 'Zuteilung ändern' };
        this.usersSelection = {};
        this.updateData = {
            userId: null,
        };
        this.changeAssignment = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunity.id)
                return;
            if (!this.updateData.userId)
                return;
            yield this.opportunityModel.assign(this.opportunity.id, parseInt(this.updateData.userId, 10));
            this.exit(true);
        });
        this.userService.getUsers().forEach((user) => {
            this.usersSelection[String(user.id)] = `${user.first_name} ${user.last_name}`;
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OpportunintyAssignmentFormComponent.prototype, "opportunity", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], OpportunintyAssignmentFormComponent.prototype, "exit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EOpportunityState !== "undefined" && enums_1.EOpportunityState) === "function" ? _a : Object)
], OpportunintyAssignmentFormComponent.prototype, "state", void 0);
OpportunintyAssignmentFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-assignment-form',
        template: /* html */ `
  <side-sheet [title]="data.title" [exit]="exit">
    <form class="default-form" (ngSubmit)="changeAssignment()" id="assignmentForm">
      <div class="row">
        <ab-select
          [options]="usersSelection"
          [showDescription]="true"
          (customModelChange)="updateData.userId = $event"
          [placeholder]="'Zugeteilter Benutzer'"
          class="col-md-12 px-0"
          [required]="true"
        ></ab-select>
      </div>
    </form>

    <button
      actions
      form="assignmentForm"
      type="submit"
      class="btn-lvl1"
      ng-class="{'btn-sending': survey.sending}"
      ng-disabled="survey.sending"
    >Zuteilung speichern</button>
  </side-sheet>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _b : Object, typeof (_c = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _c : Object])
], OpportunintyAssignmentFormComponent);
exports.default = OpportunintyAssignmentFormComponent;
